module.exports = __webpack_public_path__ + "media/components/videos_internal/dr_you_6_1-burger2-0590ece601495c2259c80a4d29b7af84.jpg";